import React, { useContext } from 'react';
import { PageContext } from '../PageContext';
import { Page } from '../types';

const Footer: React.FC = () => {
    const pageContext = useContext(PageContext);

    const handleLinkClick = (page: Page, title: string) => {
        pageContext?.switchPage(page, title);
    };

    return (
        <footer className="mt-8 py-6 border-t border-white/10 text-center text-sm text-gray-300">
            <div className="flex justify-center items-center space-x-4">
                <button onClick={() => handleLinkClick(Page.AboutUs, 'About Us')} className="hover:text-white hover:underline">About Us</button>
                <span className="select-none">·</span>
                <button onClick={() => handleLinkClick(Page.PrivacyPolicy, 'Privacy Policy')} className="hover:text-white hover:underline">Privacy</button>
                <span className="select-none">·</span>
                <button onClick={() => handleLinkClick(Page.TermsOfService, 'Terms of Service')} className="hover:text-white hover:underline">Terms</button>
                 <span className="select-none">·</span>
                <button onClick={() => handleLinkClick(Page.AISupport, 'Support')} className="hover:text-white hover:underline">Support</button>
            </div>
            <p className="mt-4 text-gray-400">© {new Date().getFullYear()} What Was It? All rights reserved.</p>
        </footer>
    );
};

export default Footer;